import { z } from 'zod';

import { OverviewSchema } from '../GoalAndOperationalPlansOverview/validators';
import { CompanyValueIncreasePlansSchema } from '../GoalAndOperationalPlansDetail/validators';
import { OtherExplanationSchema } from '@Containers/OtherExplanations/validators';

export const GoalsAndOperationalPlansSchema = z.object({
  overview: OverviewSchema.optional(),
  companyValueIncreasePlans: CompanyValueIncreasePlansSchema,
  otherDescriptions: z.array(OtherExplanationSchema).optional(),
});
